import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class PTC_CadastroClienteClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async retornaClienteById(id) {
    try {
      const result = await this.api.get(`ptc/retorna-cliente-byId/${id}`);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar cliente por id');
    }
  }

  async RetornaEnderecoCliente(clienteId) {
    try {
      const result = await this.api.get(`ptc/retorna-endereco-cliente/${clienteId}`);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar endereço do cliente');
    }
  }

  async CreateEnderecoCliente(data) {
    try {
      const result = await this.api.post('ptc/create-endereco-cliente', data);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar endereço do cliente');
    }
  }

  async UpdateEnderecoCliente(clienteId, data) {
    try {
      const result = await this.api.put(`ptc/update-endereco-cliente/${clienteId}`, data);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar endereço do cliente');
    }
  }

  async DeleteEnderecoCliente(clienteId, tipoenderecoid) {
    try {
      console.log('data-2', tipoenderecoid);
      console.log('data-1', clienteId);
      const result = await this.api.delete(`ptc/delete-endereco-cliente/${clienteId}`, { data: { tipoenderecoid } });
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar endereço do cliente');
    }
  }

  async RetornaContatos(clienteId) {
    try {
      const result = await this.api.get(`ptc/retorna-contatos/${clienteId}`);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar contatos');
    }
  }

  async CreateContato(data) {
    try {
      const result = await this.api.post('ptc/create-contato-cliente', data);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar contato');
    }
  }

  async UpdateContato(clienteId, data) {
    try {
      const result = await this.api.put(`ptc/update-contato-cliente/${clienteId}`, data);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar contato');
    }
  }

  async DeleteContato(clienteId, data) {
    try {
      const result = await this.api.delete(`ptc/delete-contato-cliente/${clienteId}`, { data });
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar contato');
    }
  }

  async RetornaTiposDocumento(clienteId) {
    try {
      const result = await this.api.get(`ptc/retorna-tipos-documento/${clienteId}`);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar tipos de documento');
    }
  }
}
